<template>
  <div>
    <v-layout wrap style="min-height:100vh;">
      <v-flex sm4 pa-5 class="background">
        <v-container class="d-flex fill-height">
          <v-layout wrap>
            <v-flex xs12>
              <v-img src="@/assets/logo.png" max-width="300" style="margin:0 auto"></v-img>
              <br />
              <h2 style="text-align:center" class="white--text">EXPRESS035</h2>
            </v-flex>
            <v-flex xs12 class="d-flex align-center">
              <h1 class="display-3 white--text">GUIATS</h1>
            </v-flex>
            <v-flex xs12 class="d-flex align-end justify-left">
              <v-flex class="white--text">
                <p class="subtitle">Contacto</p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="tel:6641237179"
                  >664 123 71 79</a>
                </p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="mailto:promocionyventas@human-express.com"
                  >promocionyventas@human-express.com</a>
                </p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="http://human-express.com/"
                  >human-express.com</a>
                </p>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex sm8 pa-5 class="primary">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs1></v-flex>
            <v-flex xs10 class="d-flex flex-row-reverse">
              <v-btn text class="primary" to="/signup">Registrate</v-btn>
            </v-flex>
            <v-flex xs1></v-flex>

            <v-flex xs1></v-flex>
            <v-flex xs10>
              <v-form ref="form" @submit.prevent="send">
                <v-layout wrap>
                  <v-flex xs12>
                    <p class="display-1 white--text">Inicia sesión</p>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="email"
                      dark
                      label="Correo Electrónico"
                      :rules="emailRule"
                      type="email"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="password"
                      dark
                      label="Contraseña"
                      :rules="requiredRule"
                      type="password"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 class="text-end">
                    <v-btn to="/restore" text class="primary">Recuperar Contraseña</v-btn>

                    <v-btn type="submit" rounded class="white" style="padding: 0 1rem">
                      Iniciar
                      sesión
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            <v-flex xs1></v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      emailRule: [
        v => !!v || "Este campo es obligatorio",
        v => /.+@.+\..+/.test(v) || "El correo debe ser valido"
      ],
      email: "",
      password: "",
      snackbar: false,
      message: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    ...mapMutations(["setUser"]),
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          email: this.email,
          password: this.password
        };

        axios
          .post(this.host + "/session/login.php", this.createFormData(data))
          .then(response => {
            console.log(response.data);

            if (response.data.status) {
              let user = response.data.userData;

              if (user.type == 0 && user.active) {
                sessionStorage.setItem(
                  "authorization",
                  response.data.userData.id
                );
                sessionStorage.setItem(
                  "user",
                  JSON.stringify(response.data.userData)
                );

                this.$router.push("/client/home");
              } else if (user.type && user.active) {
                sessionStorage.setItem(
                  "authorization",
                  response.data.userData.id
                );
                sessionStorage.setItem(
                  "user",
                  JSON.stringify(response.data.userData)
                );
                this.setUser(response.data.userData);

                this.$router.push("/admin/clients");
              } else if (!user.active) {
                this.message =
                  "Tu cuenta no está activa, ponte en contacto con Human Express";
                this.snackbar = true;
              }
            } else {
              console.log("else");
              this.message = response.data.message;
              this.snackbar = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>

<style scoped>
.background {
  background-image: url(../assets/background.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(8, 5, 15, 0.8);
  opacity: 0.8;
}
</style>